@if (dataSheets$ | async; as dataSheets) {
  <geaui-table-v3
    class="margin"
    [columnDefinitions]="(documentsTableColumns$ | async) ?? []"
    [rowsClickable]="true"
    [data]="dataSheets"
    uniquePropertyKey="url"
    [isStriped]="false"
    (rowClicked)="rowClicked($event)"
  >
  </geaui-table-v3>
}
